import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M8,4.20710631 L8,12.4444444 C8,12.7512693 7.77614237,13 7.5,13 C7.22385763,13 7,12.7512693 7,12.4444444 L7,4.20710725 L2.90380639,8.30330086 C2.70854424,8.498563 2.39196176,8.498563 2.19669961,8.30330086 C2.00143746,8.10803871 2.00143746,7.79145622 2.19669961,7.59619408 L6.4393403,3.35355339 C7.02512673,2.76776695 7.9748742,2.76776695 8.56066064,3.35355339 L12.8033013,7.59619408 C12.9985635,7.79145622 12.9985635,8.10803871 12.8033013,8.30330086 C12.6080392,8.498563 12.2914567,8.498563 12.0961945,8.30330086 L8,4.20710631 Z"/>
  </svg>
);
